<template lang="">
    <div>
        <div class="mb-3 row">
           <div class="col-md-4 ml-auto">
            <v-select
            placeholder="Personel"
            v-model="employee_id"
                    :options="employees"
                    v-if="employees && employees.length > 0"
                  ></v-select>
           </div>
        </div>
       <full-calendar
       @event-selected="onClickEvent"
       ref="calendar" :options="calendar" 
       />
    </div>
</template>
<script>
import FullCalendar from '@fullcalendar/vue';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import '@fullcalendar/core/locales/tr';
import moment from 'moment';
import request from '../../request';
export default {
  components: { FullCalendar },
  methods: {
    emit() {
      this.$emit('changeCalendar', {
        events: this.calendar.events.filter((e) => e.removable),
        service: this.service,
        employee_id: this.employee_id.value,
      });
    },
    onClickEvent(e) {},
    dateClick() {},
    onClickDay(e) {
      if (this.employee_id == null) {
        alert('LÜTFEN PERSONEL SEÇİNİZ!');
        return;
      }
      this.calendar.events.push({
        id: Math.random(),
        start: moment(e.date).format('YYYY-MM-DD HH:mm:ss'),
        end: moment(e.date).add(1, 'hours').format('YYYY-MM-DD HH:mm:ss'),
        title: this.service.name,
        removable: true,
        backgroundColor: 'pink',
        borderColor: 'pink',
      });
      this.emit();
    },
    resize: function (info) {
      let index = this.calendar.events.findIndex(
        (eve) => eve.id == info.event.id
      );
      let { editable, end, id, removable, start, title } = info.event;
      this.calendar.events[index] = {
        editable: true,
        end: moment(end).format('YYYY-MM-DD HH:mm:ss'),
        id,
        removable: true,
        start: moment(start).format('YYYY-MM-DD HH:mm:ss'),
        title,
        backgroundColor: 'pink',
      };
      this.emit();
    },
    drop(info) {
      let index = this.calendar.events.findIndex(
        (eve) => eve.id == info.event.id
      );
      let { editable, end, id, start, title } = info.event;
      this.calendar.events[index] = {
        editable: true,
        end,
        id,
        removable: true,
        start,
        title,
        borderColor: 'pink',
      };
      this.emit();
    },
    eventClick(e) {
      this.calendar.events = this.calendar.events.filter((event) => {
        if (event.removable) return event.id != e.event.id;
        else return event;
      });
      if (this.employee_id == null) {
        alert('LÜTFEN ÇALIŞAN SEÇİNİZ!');
        return;
      }
      this.emit();
    },
  },
  mounted() {},
  watch: {
    employee_id() {
      request
        .get(`/appointments/${this.employee_id.value}/employee`)
        .then((res) => {
          const { data } = res.data;
          this.calendar.events = data.map((d) => ({
            id: d.id,
            start: d.start_time,
            end: d.end_time,
            title: d.service.name,
            editable: false,
            removable: false,
            backgroundColor: d.bg,
            borderColor: d.bg,
          }));
        });
    },
  },
  props: ['employees', 'service'],
  data() {
    return {
      employee_id: null,
      calendar: {
        plugins: [timeGridPlugin, interactionPlugin],
        eventTimeFormat: {
          // like '14:30:00'
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
        },
        initialView: 'timeGridWeek',
        events: [],
        locale: 'tr',
        dateClick: this.onClickDay,
        allDaySlot: false,
        eventDrop: this.drop,
        eventClick: this.eventClick,
        eventResize: this.resize,
        scrollTime: '08:00:00',
        height: 500,
        nowIndicator: true,
        slotMinTime: '08:00:00',
        editable: true,
        droppable: true,
        slotMaxTime: '20:00:00',
        firstDay: 1,
      },
    };
  },
};
</script>
<style>
</style>